import { SealCheck } from 'phosphor-icons';
import { Avatar } from '../Avatar/Avatar';
import { PublisherInfoProps } from './types';

import { c } from '../../utils/tailwind-merge';

export const PublisherInfo = ({
  publisherName,
  showAvatar,
  isCertified,
}: PublisherInfoProps) => {
  return (
    <div className={c('flex')}>
      {showAvatar && (
        <Avatar userName={publisherName} size={24} className="bg-grey-900" />
      )}
      <span
        className={c(
          'flex items-center text-sm leading-[20px] text-grey-900',
          showAvatar ? 'pl-2' : '',
          isCertified ? 'pr-1' : ''
        )}
      >
        {publisherName}
      </span>
      {isCertified && (
        <span data-test="seal-check" aria-label="Certified Publisher">
          <SealCheck weight="fill" size={24} className="text-blue" />
        </span>
      )}
    </div>
  );
};
